import { createContext, useContext, useState } from "react";
import { ModalController } from "../../utils/modalUtils";

// Create a Context
const ModalContext = createContext<any>({});

// This will hold our update function
let updateModalContext: any;

// Context Provider
export const ModalProvider = ({ children }: any) => {
  const [state, setState] = useState(null);

  // Update the state in context
  updateModalContext = (newState: any) => {
    setState((prevState: any) => ({
      ...prevState,
      ...newState,
    }));
  };

  return (
    <ModalContext.Provider value={state}>
      {/* RENDER CHILDREN */}
      {children}
      {/* RENDER MODALS */}
      <ModalController />
    </ModalContext.Provider>
  );
};

// Custom function to get context value
export const useModalContext = () => useContext(ModalContext);

// Export the updater function
export { updateModalContext };
